import { useState } from "react";
import TextInput from "../../../../components/auth/TextInput";
import Button from "../../../../components/auth/Button";
import { requestOtp } from "../../../../api/restaurantAuth";

const PHONE_REGEX = /^09\d{9}$/;

export default function PhoneStep({ onSent }) {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setError("");
    setPhone(e.target.value.replace(/\D/g, "").slice(0, 11));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!PHONE_REGEX.test(phone)) {
      setError("شماره موبایل را به‌صورت صحیح وارد کنید (مثلاً 09123456789).");
      return;
    }

    try {
      setLoading(true);
      const data = await requestOtp(phone);
      onSent({ phone, isNewUser: data.isNewUser });
    } catch (err) {
      setError(err.response?.data?.error?.message || "ارسال کد تایید با خطا مواجه شد.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <TextInput
        id="restaurant-phone"
        name="phone"
        label="شماره موبایل"
        type="tel"
        inputMode="numeric"
        autoComplete="tel"
        dir="ltr"
        placeholder="09123456789"
        value={phone}
        maxLength={11}
        onChange={handleChange}
        error={error}
        required
        autoFocus
      />

      <Button type="submit" loading={loading}>
        دریافت کد تایید
      </Button>
    </form>
  );
}
